<template>
  <v-app
    light
    class="default-layout-page"
  >
    <HeaderToolbar>
      <HeaderActions slot="actions" />
    </HeaderToolbar>
    <v-content>
      <v-container pa-0 fill-height>
        <slot />
      </v-container>
      <SnackbarNotification />
    </v-content>
    <SatFooter />
  </v-app>
</template>

<script>
import SnackbarNotification from '@/components/common/SnackbarNotification.vue';
import SatFooter from '@/components/common/Footer.vue';
import HeaderToolbar from '@/components/common/HeaderToolbar.vue';
import HeaderActions from '@/components/common/HeaderActions.vue';

export default {
  components: {
    SnackbarNotification,
    SatFooter,
    HeaderToolbar,
    HeaderActions,
  },
};
</script>

<style lang="scss">
  .default-layout-page {
    main{
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color:#f4f2ef;
    }
  }
  .action-select-component {
      .v-input {
        .v-input__control {
          .v-input__slot {
            margin-bottom: 0px !important;
            }
          .v-messages {
            min-height: 0px !important;
          }
        }
    }
  }
.v-pagination_normal {
       justify-content: normal !important;
      }
.v-pagination_center {
       justify-content: center !important;
      }
  .po-search-pagination {
    .v-pagination {
      .v-pagination__item {
        height: 24px !important;
        min-width: 24px !important;
        margin-left: 1px !important;
        margin-right: 1px !important;
        font-weight: normal !important;
        padding-left: 5px !important;
        padding-right: 5px !important;
      }
      .v-pagination__navigation {
        height: 24px !important;
        width: 24px !important;
        margin-left: 2px !important;
        margin-right: 2px !important;
      }
      i {
        line-height: 24px !important;
      }
    }
  }
.fixed--header {
  > div {
    height: 60vh;
  }
  table {
    width: 100%;
      tbody {
      display:block;
      height:54vh;
      overflow:auto;
    }
    thead, tbody tr {
      background-color: #fff;
      z-index: 999;
      display:table;
      width:100%;
      table-layout:fixed;
    }
    th {
      background-color: #fff;
      top: 0;
      z-index: 999;
    }
  }
}
.app-font-size {
    font-size: 14px !important;
  }
.app-all {
    line-height: 1.5 !important;
  }
.v-data-footer__select {
  flex-basis: auto;

  .v-select {
      flex-basis: 50px;

      .v-select__selections {
        flex-basis: auto;
      }
    }
}
.v-list-item__content {
  flex: 1 1 auto;
  min-width: 40px;
}
 .search-header {
    border-bottom: none !important;
    font-size: 15px !important;
  }
  .black-header {
    color: black;
  }
  .event-textarea {
    textarea {
      padding: 0px !important;
      margin-top: 0px !important;
    }
  }
</style>
